import makeApiCall from "./master/axiosIndex";

export const tagsApis = {
  tagsCreate: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/tags/create`,
      method: "post",
      data,
    });
  },
  tagsList: (): Promise<any> => {
    return makeApiCall({
      url: `/tags/list`,
      method: "get",
    });
  },
  tagsDelete: (id: any): Promise<any> => {
    return makeApiCall({
      url: `/tags/delete/${id}`,
      method: "delete",
    });
  },
};
